package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.util.Res
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignContent
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundRepeat
import org.jetbrains.compose.web.css.backgroundSize
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div

@Composable
fun SvgImage(
    width: CSSSizeValue<CSSUnit.px>?=null,
    height:CSSSizeValue<CSSUnit.px>?=null,
    img:String?,
    tintColor:String?=null,
)
{
    Div(
        attrs = {
            style {
                position(Position.Relative)
                if (img!=null) backgroundImage(img)
                if (width != null) width(width) else
                    property("width", "auto")
                if (height != null) height(height) else
                    property("height", "auto")
                alignContent(AlignContent.Center)
                backgroundSize("contain")
                backgroundRepeat("no-repeat")
                backgroundPosition("center")
            }
        }
    )
}